
import { supabase } from '@/integrations/supabase/client';
import { MessageCache } from './messageCache';
import { MessageCounter } from './messageCounter';

/**
 * Manages real-time subscriptions for message updates
 */
export class MessageRealtime {
  /**
   * Sets up real-time subscription for message and conversation updates
   * @param callback Function to call when unread count changes
   * @returns Cleanup function to remove the subscription
   */
  static setupRealtimeSubscription(callback: (count: number) => void): () => void {
    const channel = supabase
      .channel('unread-messages-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'messages'
        },
        async (payload) => {
          console.log('[MessageRealtime] Real-time update received:', payload);
          // Invalidate cache and fetch new count
          MessageCache.clearCache();
          const newCount = await MessageCounter.getUnreadMessageCount();
          callback(newCount);
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations'
        },
        async (payload) => {
          console.log('[MessageRealtime] Conversation update received:', payload);
          // Invalidate cache and fetch new count
          MessageCache.clearCache();
          const newCount = await MessageCounter.getUnreadMessageCount();
          callback(newCount);
        }
      )
      .subscribe();

    return () => {
      return supabase.removeChannel(channel);
    };
  }
}
